module.exports = __webpack_public_path__ + "img/26.8a4d16ef.svg";